function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 64v832h960V64H0zm896 768H64V128h832v704zm-64-448H704V256h-64v-64H320v64h-64v128H128v384h704V384zm-64 320H192V448h128V320h64v-64h192v64h64v128h128v256zM256 512h64v128h-64V512zm128 0h64v128h-64V512zm128 0h64v128h-64V512zm128 0h64v128h-64V512z",
  fill: "#ec6f41"
}));